<template>
  <section class="main-wrapper">
    <div v-if="isShowUnApprove">
      <div class="main-wrapper-body" v-if="!unApproveMember">
        <div class="left flexible">
          <div class="left-ratio ">
            <case-share-component></case-share-component>
          </div>

          <div class="left-ratio ">
            <forum-component></forum-component>
          </div>

          <div>
            <private-plot-component></private-plot-component>
          </div>
        </div>

        <div class="right flexible">
          <div>
            <address-book-component></address-book-component>
          </div>
          <div class="right-ratio ">
            <pending-items-component></pending-items-component>
          </div>
          <div class="right-ratio ">
            <loud-speaker-component></loud-speaker-component>
          </div>
          <div class="right-ratio ">
            <triangle-component></triangle-component>
          </div>
        </div>
      </div>
      <div class="main-wrapper-body" v-else>
        <div class="empty-data">
          <img src="static/images/empty_data.png" />
          <span
            >待管理员审核通过后，将以短信和企业微信的方式通知，审核通过后可享用专家库资源。</span
          ><br />
          <span>（注：审核通过后需要退出系统再登录）</span>
        </div>
      </div>
      <footer-component></footer-component>
    </div>
    <div v-else class="centered-text">
      <p>数据加载中，请稍后......</p>
    </div>
  </section>
</template>

<script>
import FooterComponent from "../../components/home/FooterComponent";
import AddressBookComponent from "../../components/home/AddressBookComponent";
import LoudSpeakerComponent from "../../components/home/LoudSpeakerComponent";
import ForumComponent from "../../components/home/ForumComponent";
import TriangleComponent from "../../components/home/TriangleComponent";
import PendingItemsComponent from "../../components/home/PendingItemsComponent";
import PrivatePlotComponent from "../../components/home/PrivatePlotComponent";
import CaseShareComponent from "../../components/home/CaseShareComponent";
import { mapState } from "vuex";
import Animation from "../../components/loading/animation";

export default {
  name: "MainCopy",
  components: {
    CaseShareComponent,
    PrivatePlotComponent,
    PendingItemsComponent,
    TriangleComponent,
    ForumComponent,
    LoudSpeakerComponent,
    AddressBookComponent,
    FooterComponent,
    Animation
  },
  data() {
    return {
      superPower: false,
      unApproveMember: false
    };
  },
  watch: {
    userPower(newVal) {
      this.superPower = this.$store.state.userPowerStore.superPower;
      this.unApproveMember = this.$store.state.userPowerStore.unApproveMember;
    },
    isShowUnApprove(newVal) {
      this.isShow = newVal;
    }
  },
  created() {
    this.getAuth();
  },
  mounted() {},

  methods: {
    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户部门管理权限
        this.superPower = this.$store.state.userPowerStore.superPower;
        this.unApproveMember = this.$store.state.userPowerStore.unApproveMember;
      });
    }
  },

  computed: {
    ...mapState({
      userPower: state => state.userPowerStore.userPower,
      isShowUnApprove: state => state.userPowerStore.isShowUnApprove
    })
  }
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  width: 100%;
  height: calc(100vh - 69px);
  min-height: var(--height-critical-value);
  display: flex;
  flex-direction: column;
  /*todo 调整临界值,高度小于这个值,将会设置页面的高度为700px,而不是铺满全屏*/
  --height-critical-value: 700px;
  /*左边与右边的height设置的位置不一致,导致左边需要计算padding,右边不需要计算padding*/
  /*左边每一个模块的高度 其中88px是底部技术信息高度 57.?px + 模块之间的padding 30px*/
  --height-critical-left-value: calc(
    (max(calc(100vh - 64px), var(--height-critical-value)) - 264px) / 2
  );
  /*右边除了通讯录的高度 其中88px是底部技术信息高度 57.?px + 通讯录 97px*/
  --height-critical-right-value: calc(
    (max(calc(100vh - 49px), var(--height-critical-value)) - 165px) / 3
  );
  /*将页面宽度分成8分占5分*/
  --width-critical-left-value: calc(100% / 8 * 5);
  /*将页面宽度分成8分占3分*/
  --width-critical-right-value: calc(100% / 8 * 3);
  &-body {
    background-color: rgb(238, 245, 252);
    display: flex;
    flex-direction: row;
    .left {
      width: var(--width-critical-left-value);
      /*选中除了第三节点的所有节点*/
      &-ratio {
        /*限制每一个格子的高度*/
        height: var(--height-critical-left-value);
        overflow: auto;
      }
    }
    .right {
      width: var(--width-critical-right-value);
      /*选中除了第一节点之后的所有节点*/
      &-ratio {
        /*限制每一个格子的高度*/
        height: var(--height-critical-right-value);
        overflow: auto;
      }
    }
    .right > *,
    .left > * {
      padding: 5px 5px 10px 5px;
    }
    .flexible {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    /*暂无数据div*/
    .empty-data {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: calc(100vh - 103px);
      img {
        width: 30%;
      }
      span {
        font-size: 18px;
        color: #999999;
      }
    }
  }
  .centered-text {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/MainCopy.vue